import { createContext } from 'react';

export type ExitContext = {
    shouldPreventUnload: boolean;
    setShouldPreventUnload(shouldPreventUnload: boolean): void;
    exit(): void;
};

export const exitContext = createContext<ExitContext>(undefined! as ExitContext);
